<div class="multiple-values" [class.column]="isColumn()">
  @for (value of data.values; track value) {
    <app-dashboard-value-display
      (loaded)="valueItemLoaded($index)"
      [item]="getItemForValue(value, $index)"
    ></app-dashboard-value-display>
  }
</div>
